import React from "react";

export function BtnSpinner({ loading, children }: { loading: boolean; children: React.ReactNode }) {
  if (!loading) return <>{children}</>;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <span className="btnSpinner" />
      {children}
    </span>
  );
}
